/* ==========================================================================
 * bs-product.js - gedrag van de Birdstopper-productpagina (sections/bs-product.liquid)
 * --------------------------------------------------------------------------
 * - variant kiezen met de knoppen Diameter en Lengte, de tabel Alle maten,
 *   de fotominiaturen of het keuzemenu (andere producten)
 * - bij wisselen bijwerken: prijs, prijs per meter, beschikbaarheid, foto,
 *   palletblok (event bs:variant), gemarkeerde tabelrij, artikelnummer, URL
 * - toevoegen aan de winkelwagen via window.BBWinkel.pakketToevoegen, zodat de
 *   teller in de kop meeloopt (BBWinkel.meldWijziging)
 * - op de telefoon: inklapbare secties, fotostrook met stippen, vaste koopbalk
 * - pre-order: is de maat op, dan verdwijnt de koopknop en komt er een knop
 *   "Pre-order aanvragen" die de gedeelde dialoog van snippets/bs-preorder.liquid
 *   opent (window.BSPreorder, zie nacht-16-09/pre-order-contract.md). Vraagt de
 *   klant meer dan er vrij is, dan gaat er geen verzoek naar Shopify maar komt er
 *   een melding met twee knoppen. Alle pre-orderteksten staan in die snippet.
 *
 * Prijzen: alle bedragen gaan door window.BSBtw.prijsHtml. Hier wordt niets met
 * geld verrekend behalve de prijs per meter voor de weergave (prijs / meters,
 * afgerond op hele centen, net als in de Liquid).
 * ========================================================================== */
(function () {
  'use strict';

  var BRON = 'Productpagina';

  /* Klantteksten uit window.BSTekst (snippets/bs-teksten.liquid, sleutels bs.* in de
     locale-bestanden). Ontbreekt een tekst, dan de Nederlandse terugval die hier
     in de code staat. {naam} in een tekst wordt ingevuld met waarden.naam. */
  function tk(sleutel, terug, waarden) {
    var bron = window.BSTekst;
    var s = (bron && typeof bron[sleutel] === 'string' && bron[sleutel] !== '' && bron[sleutel].indexOf('translation missing') !== 0) ? bron[sleutel] : terug;
    if (!waarden) { return s; }
    return String(s).replace(/\{(\w+)\}/g, function (heel, naam) {
      return Object.prototype.hasOwnProperty.call(waarden, naam) ? String(waarden[naam]) : heel;
    });
  }

  var TEKST = {
    toevoegen: tk('in_winkelwagen', 'In winkelwagen'),
    bezig: tk('bezig_toevoegen', 'Bezig met toevoegen'),
    preorder: tk('preorder_aanvragen', 'Pre-order aanvragen'),
    voorraad: {
      op: tk('op_voorraad', 'Op voorraad'),
      na: tk('na_voorraad', 'Tijdelijk niet op voorraad, wel te bestellen'),
      uit: tk('uitverkocht', 'Tijdelijk uitverkocht')
    },
    lengte_uit: tk('preorder_vlag', 'pre-order'),
    gelukt: function (n, label) { return tk('pp_gelukt', 'Toegevoegd aan je winkelwagen: {aantal}x {product}.', { aantal: n, product: label }); },
    bekijk: tk('pp_bekijk', 'Bekijk je winkelwagen'),
    mislukt: tk('pp_mislukt', 'Dit is niet toegevoegd aan je winkelwagen.'),
    mislukt_verder: tk('pp_mislukt_verder', 'Probeer het opnieuw of neem contact met ons op.'),
    geen_verbinding: tk('pp_geen_verbinding', 'Er ging iets mis met de verbinding.')
  };

  /* De gedeelde pre-ordermodule. Staat de snippet niet op de pagina, dan geeft dit
     null terug en valt alles terug op het oude gedrag (link naar de contactpagina). */
  function po() {
    var P = window.BSPreorder;
    return (P && typeof P.controleer === 'function') ? P : null;
  }

  function wortelPad() {
    var S = window.Shopify;
    return (S && S.routes && S.routes.root) ? S.routes.root : '/';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function bedrag(c) {
    if (window.BSBtw && window.BSBtw.bedrag) { return window.BSBtw.bedrag(c); }
    return '€ ' + (Math.round(c) / 100).toFixed(2).replace('.', ',');
  }
  function exclCenten(c) {
    if (window.BSBtw && window.BSBtw.exclCenten) { return window.BSBtw.exclCenten(c); }
    return Math.round(Number(c) * 100 / 121);
  }
  function prijsHtml(c, opties) {
    if (window.BSBtw && window.BSBtw.prijsHtml) { return window.BSBtw.prijsHtml(c, opties); }
    return '<span class="bs-prijs">' + bedrag(c) + '</span>';
  }
  function perMeter(v) {
    return v.meters > 0 ? Math.round(v.prijs / v.meters) : 0;
  }
  function meterGetal(m) {
    return String(Math.round(m * 10) / 10).replace('.', ',');
  }

  function alles(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function init(root) {
    if (!root || root.__bsPP) { return; }
    var bron = root.querySelector('script[data-pp-data]');
    if (!bron) { return; }
    var data;
    try { data = JSON.parse(bron.textContent); } catch (e) { return; }
    root.__bsPP = true;

    var varianten = data.varianten || [];
    var perId = {};
    varianten.forEach(function (v) { perId[String(v.id)] = v; });
    var huidig = perId[String(data.gekozen)] || varianten[0];
    if (!huidig) { return; }

    var el = function (naam) { return root.querySelector('[data-pp="' + naam + '"]'); };
    var buhne = el('buhne');
    var form = el('form');
    var aantalVeld = el('aantal');
    var hoofdKnop = el('toevoegen');
    var poKnop = el('preorder-knop');
    var poVak = el('preorder');
    var melding = el('melding');
    var toast = el('toast');
    var bezig = false;
    var wagen = null;   /* laatst gelezen /cart.js, alleen voor de controle vooraf */

    /* ---------------- variant kiezen ---------------- */

    function lengtesHtml(d) {
      var lijst = varianten.filter(function (v) { return v.diameter === d; })
        .sort(function (a, b) { return a.meters - b.meters; });
      return lijst.map(function (v) {
        var aan = v.id === huidig.id;
        var rol = v.rollen === 1 ? tk('rol_een', '1 rol') : tk('rollen', '{aantal} rollen', { aantal: v.rollen });
        if (v.voorraad === 'uit') { rol += ', ' + TEKST.lengte_uit; }
        return '<button type="button" class="bs-pp-optie' + (aan ? ' is-aan' : '') + (v.voorraad === 'uit' ? ' is-uit' : '')
          + '" data-variant="' + v.id + '" aria-pressed="' + (aan ? 'true' : 'false') + '">'
          + '<b>' + meterGetal(v.meters) + ' ' + tk('meter', 'meter') + '</b>'
          + '<small class="bs-pp-alleen-desktop">' + esc(rol) + '</small>'
          + '<small class="bs-pp-alleen-mobiel">' + prijsHtml(v.prijs, { maat: 'klein' }) + '</small>'
          + (v.voorraad === 'uit' ? '<small class="bs-pp-po-vlag">' + esc(TEKST.lengte_uit) + '</small>' : '')
          + '</button>';
      }).join('');
    }

    function zetLengtes() {
      var doos = el('lengtes');
      if (!doos) { return; }
      var zelfde = doos.getAttribute('data-diameter') === String(huidig.diameter);
      if (zelfde) {
        alles(doos, '[data-variant]').forEach(function (k) {
          var aan = k.getAttribute('data-variant') === String(huidig.id);
          k.classList.toggle('is-aan', aan);
          k.setAttribute('aria-pressed', aan ? 'true' : 'false');
        });
      } else {
        doos.innerHTML = lengtesHtml(huidig.diameter);
        doos.setAttribute('data-diameter', String(huidig.diameter));
      }
      doos.setAttribute('data-aantal', String(doos.children.length));
    }

    function zetFoto(scrollen) {
      var fotos = alles(root, '[data-variant-foto]');
      var heeft = fotos.some(function (f) { return f.getAttribute('data-variant-foto') === String(huidig.id); });
      if (heeft) {
        fotos.forEach(function (f) { f.hidden = f.getAttribute('data-variant-foto') !== String(huidig.id); });
        var img = root.querySelector('[data-variant-foto="' + huidig.id + '"] img');
        if (img && img.loading === 'lazy') { img.loading = 'eager'; }
      }
      alles(root, '[data-mini-variant]').forEach(function (m) {
        if (huidig.diameter) { m.hidden = m.getAttribute('data-diameter') !== String(huidig.diameter); }
      });
      var weggevallen = zetSkuFotos();
      if (scrollen || weggevallen) { naarDia(0); } else { zetDiaAan(huidigeDia()); }
    }

    function zetVoorraad() {
      alles(root, '[data-pp="voorraad"]').forEach(function (v) {
        v.setAttribute('data-stand', huidig.voorraad);
        var t = v.querySelector('[data-pp="voorraad-tekst"]');
        if (t) { t.textContent = TEKST.voorraad[huidig.voorraad] || ''; }
      });
      var uit = huidig.voorraad === 'uit';
      root.classList.toggle('is-uitverkocht', uit);
      if (!bezig) {
        /* Uitverkocht: geen koopknop meer (verbergen, niet uitgrijzen) maar de
           pre-orderknop op dezelfde plek. De kleine knoppen in de balken worden
           pre-orderknoppen en blijven dus klikbaar. */
        if (hoofdKnop) {
          hoofdKnop.hidden = uit;
          hoofdKnop.disabled = false;
          var kt = el('knoptekst');
          if (kt) { kt.textContent = TEKST.toevoegen; }
        }
        if (poKnop) { poKnop.hidden = !uit; }
        alles(root, '[data-pp="toevoegen-extra"]').forEach(function (k) {
          k.disabled = false;
          k.textContent = uit ? TEKST.preorder : TEKST.toevoegen;
        });
      }
      alles(root, '[data-pp-zeker="voorraad"]').forEach(function (z) { z.hidden = uit; });
      zetPreorderVak(uit);
    }

    /* De vaste uitleg onder de knop bij een uitverkochte maat (melding M1 uit het
       pre-ordercomponent, zonder knop: die staat hierboven al). */
    function zetPreorderVak(uit) {
      if (!poVak) { return; }
      var P = po();
      var html = (uit && P) ? P.meldingHtml('uit', { variantId: huidig.id, bron: BRON, knoppen: false }) : '';
      poVak.innerHTML = html;
      poVak.hidden = !html;
    }

    function zetPrijs() {
      var p = el('prijs');
      if (p) { p.innerHTML = prijsHtml(huidig.prijs, { maat: 'groot', achtervoegsel: true }); }
      var a = el('anders');
      if (a) {
        a.innerHTML = '<span class="bs-incl">' + bedrag(exclCenten(huidig.prijs)) + ' ' + tk('btw_excl', 'excl. btw') + '</span>'
          + '<span class="bs-excl">' + bedrag(huidig.prijs) + ' ' + tk('btw_incl', 'incl. btw') + '</span>';
      }
      var pm = el('permeter');
      if (pm) {
        var c = perMeter(huidig);
        pm.innerHTML = c > 0 ? prijsHtml(c, { maat: 'klein' }) + ' ' + tk('per_meter', 'per meter') : '';
      }
      var pk = el('prijs-klein');
      if (pk) { pk.innerHTML = prijsHtml(huidig.prijs, { maat: 'normaal' }); }
      var pv = el('prijs-vast');
      if (pv) { pv.innerHTML = prijsHtml(huidig.prijs, { maat: 'normaal' }); }
      alles(root, '[data-pp="label"]').forEach(function (l) { l.textContent = huidig.label; });
      alles(root, '[data-pp="sku"]').forEach(function (s) { s.textContent = huidig.sku || ''; });
    }

    function zetTabel() {
      alles(root, '[data-rij-variant]').forEach(function (rij) {
        var aan = rij.getAttribute('data-rij-variant') === String(huidig.id);
        rij.classList.toggle('is-gekozen', aan);
        var pil = rij.querySelector('.bs-pp-pil-gekozen');
        var link = rij.querySelector('[data-kies-variant]');
        if (pil) { pil.hidden = !aan; }
        if (link) { link.hidden = aan; }
      });
    }

    function zetDiameters() {
      alles(root, '[data-pp="diameters"] [data-diameter]').forEach(function (k) {
        var aan = k.getAttribute('data-diameter') === String(huidig.diameter);
        k.classList.toggle('is-aan', aan);
        k.setAttribute('aria-pressed', aan ? 'true' : 'false');
      });
      var sel = el('select');
      if (sel) { sel.value = String(huidig.id); }
    }

    function zetUrl() {
      if (!window.history || !window.history.replaceState) { return; }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(huidig.id));
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) { /* oude browser: dan blijft de URL staan */ }
    }

    function kies(v, opties) {
      if (!v) { return; }
      opties = opties || {};
      var anders = v.id !== huidig.id;
      huidig = v;
      var idVeld = el('variant-id');
      if (idVeld) { idVeld.value = String(v.id); }
      zetDiameters();
      zetLengtes();
      zetPrijs();
      zetVoorraad();
      zetTabel();
      zetFoto(opties.fotoNaarVoren !== false);
      if (anders) {
        document.dispatchEvent(new CustomEvent('bs:variant', { detail: { id: v.id } }));
        zetUrl();
        verbergMelding();
      }
    }

    function kiesDiameter(d) {
      if (d === huidig.diameter) { return; }
      var kandidaten = varianten.filter(function (v) { return v.diameter === d; });
      if (!kandidaten.length) { return; }
      /* dichtstbijzijnde lengte; bij gelijke afstand de langere; liefst niet uitverkocht */
      kandidaten.sort(function (a, b) {
        var da = Math.abs(a.meters - huidig.meters);
        var db = Math.abs(b.meters - huidig.meters);
        if (da !== db) { return da - db; }
        return b.meters - a.meters;
      });
      var beste = kandidaten[0];
      if (beste.voorraad === 'uit') {
        var beschikbaar = kandidaten.filter(function (v) { return v.voorraad !== 'uit'; })[0];
        if (beschikbaar && Math.abs(beschikbaar.meters - huidig.meters) === Math.abs(beste.meters - huidig.meters)) {
          beste = beschikbaar;
        }
      }
      kies(beste);
    }

    /* ---------------- galerij ---------------- */

    /* Alleen de zichtbare dia's tellen mee. Een galerijfoto met "alleen tonen bij artikelnummer" staat bij
       andere maten op hidden; zou je die meetellen, dan springen miniaturen en stippen naar de verkeerde foto.
       Daarom rekenen we altijd met het data-dia-nummer van de dia en niet met zijn plek in de rij. */
    function dias() { return buhne ? alles(buhne, '.bs-pp-dia').filter(function (d) { return !d.hidden; }) : []; }

    function huidigeDia() {
      if (!buhne || !buhne.clientWidth) { return 0; }
      var zicht = dias();
      var d = zicht[Math.round(buhne.scrollLeft / buhne.clientWidth)];
      return d ? (parseInt(d.getAttribute('data-dia'), 10) || 0) : 0;
    }

    /* Galerijfoto's die een vaste maat noemen (bijvoorbeeld "8 meter, 15 cm") alleen bij die maat tonen. */
    function zetSkuFotos() {
      var sku = String(huidig.sku || '');
      var verborgenAan = false;
      var nu = huidigeDia();
      alles(root, '[data-alleen-sku]').forEach(function (e) {
        var weg = e.getAttribute('data-alleen-sku') !== sku;
        e.hidden = weg;
        if (weg && e.classList.contains('bs-pp-dia') && e.getAttribute('data-dia') === String(nu)) { verborgenAan = true; }
      });
      return verborgenAan;
    }

    function zetDiaAan(i) {
      alles(root, '[data-stip]').forEach(function (s) {
        s.classList.toggle('is-aan', s.getAttribute('data-stip') === String(i));
      });
      alles(root, '.bs-pp-mini-knop').forEach(function (m) {
        var aan = i === 0
          ? m.getAttribute('data-mini-variant') === String(huidig.id)
          : m.getAttribute('data-mini-dia') === String(i);
        m.classList.toggle('is-aan', aan);
      });
    }

    function naarDia(i) {
      var lijst = dias();
      var doel = buhne ? buhne.querySelector('.bs-pp-dia[data-dia="' + i + '"]') : null;
      if (doel && doel.hidden) { doel = null; i = 0; }
      if (!doel) { doel = lijst[0]; i = 0; }
      if (buhne && doel) {
        var links = doel.offsetLeft - lijst[0].offsetLeft;
        if (typeof buhne.scrollTo === 'function') {
          buhne.scrollTo({ left: links, behavior: 'smooth' });
        } else {
          buhne.scrollLeft = links;
        }
      }
      zetDiaAan(i);
    }

    if (buhne) {
      var wacht = null;
      buhne.addEventListener('scroll', function () {
        if (wacht) { window.cancelAnimationFrame(wacht); }
        wacht = window.requestAnimationFrame(function () { zetDiaAan(huidigeDia()); });
      }, { passive: true });
    }

    /* ---------------- aantal ---------------- */

    function aantal() {
      var n = parseInt(aantalVeld ? aantalVeld.value : '1', 10);
      if (!isFinite(n) || n < 1) { n = 1; }
      if (n > 9999) { n = 9999; }
      return n;
    }
    function zetAantal(n) {
      if (aantalVeld) { aantalVeld.value = String(Math.max(1, Math.min(9999, n))); }
    }
    if (aantalVeld) {
      aantalVeld.addEventListener('change', function () { zetAantal(aantal()); });
      aantalVeld.addEventListener('input', function () {
        var schoon = aantalVeld.value.replace(/[^0-9]/g, '');
        if (schoon !== aantalVeld.value) { aantalVeld.value = schoon; }
      });
    }

    /* ---------------- winkelwagen ---------------- */

    function verbergMelding() {
      if (melding) { melding.hidden = true; melding.innerHTML = ''; }
      if (toast) { toast.hidden = true; toast.innerHTML = ''; }
    }

    var toastTimer = null;
    /* stand: 'goed' | 'fout' | 'po'. Bij 'po' brengt het pre-ordercomponent zijn
       eigen vlak mee, dus zet deze doos zichzelf dan uit de weg (klasse is-po). */
    function toon(stand, html, alsToast) {
      var doel = alsToast ? toast : melding;
      var ander = alsToast ? melding : toast;
      if (ander) { ander.hidden = true; ander.innerHTML = ''; }
      if (!doel) { return; }
      doel.className = doel.className.replace(/\bis-(goed|fout|po)\b/g, '').replace(/\s+/g, ' ').trim() + ' is-' + stand;
      doel.innerHTML = html;
      doel.hidden = false;
      if (alsToast) {
        if (toastTimer) { window.clearTimeout(toastTimer); }
        toastTimer = window.setTimeout(function () { toast.hidden = true; }, stand === 'po' ? 15000 : 7000);
      }
    }

    /* ---------------- voorraadcontrole vooraf en het vangnet na een 422 ---------------- */

    function wagenLezen() {
      if (!window.BBWinkel || typeof window.BBWinkel.winkelwagenLezen !== 'function') {
        return Promise.resolve(null);
      }
      return window.BBWinkel.winkelwagenLezen().then(function (w) {
        wagen = w;
        return w;
      }).catch(function () {
        /* Kan de winkelwagen niet gelezen worden, dan slaan we de controle over en
           laten we Shopify het zeggen. Het vangnet na de 422 vangt dat op. */
        wagen = null;
        return null;
      });
    }

    function alInWagen(id) {
      var P = po();
      return (P && wagen) ? P.inWagen(wagen, id) : 0;
    }

    /* Bij een 422 stuurt Shopify geen secties mee, dus halen we het telbolletje apart op. */
    function tellerVerversen() {
      if (typeof window.fetch !== 'function') { return Promise.resolve(); }
      return window.fetch(wortelPad() + '?sections=cart-icon-bubble', {
        method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' }
      }).then(function (a) {
        return a && a.ok ? a.json() : null;
      }).then(function (j) {
        var html = j && j['cart-icon-bubble'];
        var oud = document.getElementById('cart-icon-bubble');
        if (!html || !oud) { return; }
        var doos = document.createElement('div');
        doos.innerHTML = html;
        var nieuw = doos.querySelector('#cart-icon-bubble');
        oud.innerHTML = nieuw ? nieuw.innerHTML : doos.innerHTML;
      }).catch(function () { /* de teller bijwerken is geen voorwaarde */ });
    }

    /**
     * Vangnet als Shopify toch weigert (de controle vooraf kan achterlopen).
     * Nooit aannemen dat er niets is toegevoegd: winkelwagen opnieuw lezen en de
     * melding baseren op wat er NU van deze maat in ligt.
     *
     * @param {object} [nieuweWagen] het verse /cart.js als de aanroeper dat al heeft
     *                 (BSPreorder.voegToe geeft het mee); anders halen we het zelf.
     */
    function na422(v, alsToast, nieuweWagen) {
      var eerst = nieuweWagen
        ? Promise.resolve((wagen = nieuweWagen))
        : wagenLezen();
      return eerst.then(function (w) {
        if (w) {
          try { window.BBWinkel.meldWijziging(w); } catch (e) { /* teller is geen voorwaarde */ }
        }
        return tellerVerversen();
      }).then(function () {
        var P = po();
        if (!P) {
          toon('fout', esc(TEKST.mislukt + ' ' + TEKST.mislukt_verder), alsToast);
          return;
        }
        toon('po', P.meldingHtml('na422', {
          variantId: v.id, inWagenNu: alInWagen(v.id), bron: BRON
        }), alsToast);
      });
    }

    function preorderOpenen(n) {
      var P = po();
      if (!P) { return false; }
      return P.open({ variantId: huidig.id, aantal: n || aantal(), bron: BRON }) !== false;
    }

    function knoppenBezig(aan) {
      var alle = [hoofdKnop].concat(alles(root, '[data-pp="toevoegen-extra"]')).filter(Boolean);
      alle.forEach(function (k) {
        if (aan) {
          k.setAttribute('aria-busy', 'true');
          k.disabled = true;
        } else {
          k.removeAttribute('aria-busy');
        }
      });
      var kt = el('knoptekst');
      if (aan && kt) { kt.textContent = TEKST.bezig; }
      if (!aan) { zetVoorraad(); }
    }

    /* ---------------- K4: de pre-orderknop overleeft de succesmelding ----------------
     * Melding M2 zegt: "Zet die alvast in je winkelwagen EN vraag de overige {Y}
     * aan als pre-order". Tikte de klant op de eerste knop, dan verving de
     * succesmelding de hele M2-melding en was de tweede helft van die zin niet
     * meer uit te voeren; de enige weg terug was nog eens op "In winkelwagen"
     * tikken om melding M3 te krijgen. Nu reist de pre-orderknop uit die melding
     * mee en staat hij onder de bevestiging.
     * De knop wordt letterlijk overgenomen (outerHTML) uit de melding die het
     * pre-ordercomponent zelf heeft gemaakt: geen tweede plek met teksten of
     * data-attributen, en het contract blijft van bs-preorder.js.
     */
    function restKnopHtml(knopInMelding) {
      var vlak = knopInMelding && knopInMelding.closest ? knopInMelding.closest('.bs-po-melding') : null;
      var po = vlak ? vlak.querySelector('[data-bs-po-open]') : null;
      return po ? po.outerHTML : '';
    }

    function metRest(html, rest) {
      if (!rest) { return html; }
      return html + '<div class="bs-po-melding-knoppen">' + rest + '</div>';
    }

    function toevoegen(alsToast, aantalNu, rest) {
      if (bezig) { return; }
      /* Uitverkocht: niets naar Shopify, meteen de pre-orderdialoog. */
      if (huidig.voorraad === 'uit') { preorderOpenen(); return; }
      if (!window.BBWinkel || typeof window.BBWinkel.pakketToevoegen !== 'function') {
        /* zonder de winkelwagenlaag: gewoon het Shopify-formulier versturen */
        if (form) { form.submit(); }
        return;
      }
      var n = aantalNu || aantal();
      var v = huidig;
      bezig = true;
      knoppenBezig(true);
      verbergMelding();

      /* Eerst kijken of het gevraagde aantal past, samen met wat er al in de wagen
         ligt. Past het niet, dan gaat er geen verzoek naar Shopify maar komt er een
         melding met de knoppen "X in winkelwagen" en "Pre-order aanvragen". */
      wagenLezen().then(function () {
        var P = po();
        if (P) {
          var u = P.controleer({ variantId: v.id, gevraagd: n, inWagen: alInWagen(v.id) });
          if (u.soort !== 'ok') {
            toon('po', P.meldingHtml(u, { bron: BRON }), alsToast);
            return null;
          }
        }
        /* Via het pre-ordercomponent, want /cart/add.js zet in de items[]-vorm
           stilletjes een dak van 50 stuks per artikel op de winkelwagen (gemeten,
           zie de kop van bs-preorder.js). voegToe() knipt het aantal in stukken van
           50 in de enkelvoudige vorm en zegt daarna uit /cart.js wat er echt in ligt,
           zodat "91 in winkelwagen" ook echt 91 oplevert. */
        if (P && typeof P.voegToe === 'function') {
          return P.voegToe([{ id: v.id, quantity: n }], { secties: 'cart-icon-bubble' })
            .then(function (uit) {
              if (uit.wagen) { wagen = uit.wagen; }
              if (uit.fout) {
                var uitleg = uit.fout.bericht ? String(uit.fout.bericht) : '';
                toon('fout', esc(TEKST.mislukt + ' ' + (uitleg || (TEKST.geen_verbinding + ' ' + TEKST.mislukt_verder))), alsToast);
                return null;
              }
              try { window.BBWinkel.meldWijziging(uit.antwoord || uit.wagen); } catch (e) { /* teller bijwerken is geen voorwaarde */ }
              /* Te weinig voorraad is geen storing maar een tekort: zelfde melding
                 M4 als vroeger na een 422 van Shopify. */
              if (uit.tekort[String(v.id)]) { return na422(v, alsToast, uit.wagen); }
              var gelegd = uit.toegevoegd[String(v.id)] || n;
              var link = ' <a href="' + esc(data.winkelwagenUrl || '/cart') + '">' + TEKST.bekijk + '</a>';
              toon('goed', metRest(esc(TEKST.gelukt(gelegd, (data.product ? data.product + ' ' : '') + v.label)) + link, rest), alsToast);
              return null;
            });
        }

        return window.BBWinkel.pakketToevoegen(
          { regels: [{ product: { id: v.id, variant_id: v.id }, aantal: n }] },
          { secties: 'cart-icon-bubble' }
        ).then(function (uit) {
          try { window.BBWinkel.meldWijziging(uit.antwoord); } catch (e) { /* teller bijwerken is geen voorwaarde */ }
          var link = ' <a href="' + esc(data.winkelwagenUrl || '/cart') + '">' + TEKST.bekijk + '</a>';
          toon('goed', metRest(esc(TEKST.gelukt(n, (data.product ? data.product + ' ' : '') + v.label)) + link, rest), alsToast);
        });
      }).catch(function (fout) {
        if (fout && fout.status === 422) { return na422(v, alsToast); }
        var uitleg = fout && fout.uitlegVanShopify ? String(fout.uitlegVanShopify) : '';
        var tekst = TEKST.mislukt + ' ' + (uitleg ? uitleg : (fout && fout.allesOfNiets ? TEKST.mislukt_verder : TEKST.geen_verbinding + ' ' + TEKST.mislukt_verder));
        toon('fout', esc(tekst), alsToast);
      }).then(function () {
        bezig = false;
        knoppenBezig(false);
      });
    }

    /* ---------------- klikken ---------------- */

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) { return; }

      var k = t.closest('[data-pp="diameters"] [data-diameter]');
      if (k) { e.preventDefault(); kiesDiameter(parseInt(k.getAttribute('data-diameter'), 10)); return; }

      k = t.closest('[data-pp="lengtes"] [data-variant]');
      if (k) { e.preventDefault(); kies(perId[k.getAttribute('data-variant')]); return; }

      k = t.closest('[data-mini-variant]');
      if (k) {
        e.preventDefault();
        var mv = perId[k.getAttribute('data-mini-variant')];
        if (mv && mv.id !== huidig.id) { kies(mv); } else { naarDia(0); }
        return;
      }

      k = t.closest('[data-mini-dia]');
      if (k) { e.preventDefault(); naarDia(parseInt(k.getAttribute('data-mini-dia'), 10) || 0); return; }

      k = t.closest('[data-pp="min"]');
      if (k) { e.preventDefault(); zetAantal(aantal() - 1); return; }
      k = t.closest('[data-pp="plus"]');
      if (k) { e.preventDefault(); zetAantal(aantal() + 1); return; }

      /* "X in winkelwagen" uit de melding bij deels op voorraad: dat afhandelen blijft
         van deze pagina (het pre-ordercomponent levert alleen de knop). */
      k = t.closest('[data-bs-po-actie="winkelwagen"]');
      if (k) {
        e.preventDefault();
        var hoeveel = parseInt(k.getAttribute('data-aantal'), 10) || 1;
        var welke = perId[String(k.getAttribute('data-variant-id'))];
        if (!welke || welke.id === huidig.id) {
          /* K4: de pre-orderknop uit dezelfde melding meenemen, zodat de tweede
             helft van melding M2 uitvoerbaar blijft na het toevoegen. */
          var rest = restKnopHtml(k);
          zetAantal(hoeveel);
          toevoegen(!!t.closest('[data-pp="toast"]'), hoeveel, rest);
        }
        return;
      }

      /* De grote knop bij een uitverkochte maat. Zonder JavaScript is het een link
         naar de contactpagina; met JavaScript opent hij de dialoog. */
      k = t.closest('[data-pp="preorder-knop"]');
      if (k) {
        if (preorderOpenen()) { e.preventDefault(); }
        return;
      }

      k = t.closest('[data-pp="toevoegen-extra"]');
      if (k) { e.preventDefault(); toevoegen(true); return; }

      k = t.closest('[data-rij-variant]');
      if (k && !t.closest('.bs-pp-pil-gekozen')) {
        var rv = perId[k.getAttribute('data-rij-variant')];
        if (rv) {
          e.preventDefault();
          kies(rv);
          var koop = root.querySelector('.bs-pp-koop');
          if (koop && koop.getBoundingClientRect().bottom < 0 && koop.scrollIntoView) {
            koop.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
        return;
      }

      k = t.closest('.bs-pp-klap');
      if (k) {
        e.preventDefault();
        var sectie = k.closest('.bs-pp-sectie');
        if (sectie) {
          var open = !sectie.classList.contains('is-open');
          sectie.classList.toggle('is-open', open);
          k.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        return;
      }

      k = t.closest('[data-pp-naar], .bs-pp-nav a[href^="#"]');
      if (k) {
        var id = (k.getAttribute('href') || '').replace(/^#/, '');
        var doel = id ? document.getElementById(id) : null;
        if (doel) {
          e.preventDefault();
          openSectie(doel);
          doel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (window.history && window.history.replaceState) {
            try { window.history.replaceState(window.history.state, '', '#' + id); } catch (e2) { /* niet erg */ }
          }
        }
      }
    });

    function openSectie(sectie) {
      if (!sectie || !sectie.classList.contains('bs-pp-sectie')) { return; }
      sectie.classList.add('is-open');
      var knop = sectie.querySelector('.bs-pp-klap');
      if (knop) { knop.setAttribute('aria-expanded', 'true'); }
    }

    var sel = el('select');
    if (sel) {
      sel.addEventListener('change', function () { kies(perId[sel.value]); });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        toevoegen(false);
      });
    }

    /* ---------------- sectienavigatie en vaste balk ---------------- */

    if ('IntersectionObserver' in window) {
      var navLinks = alles(root, '.bs-pp-nav a[data-nav]');
      if (navLinks.length) {
        var zichtbaar = {};
        var navObs = new IntersectionObserver(function (items) {
          items.forEach(function (it) { zichtbaar[it.target.getAttribute('data-sectie')] = it.isIntersecting; });
          var eerste = null;
          alles(root, '.bs-pp-sectie[data-sectie]').some(function (s) {
            if (zichtbaar[s.getAttribute('data-sectie')]) { eerste = s.getAttribute('data-sectie'); return true; }
            return false;
          });
          if (eerste) {
            navLinks.forEach(function (a) { a.classList.toggle('is-aan', a.getAttribute('data-nav') === eerste); });
          }
        }, { rootMargin: '-35% 0px -55% 0px' });
        alles(root, '.bs-pp-sectie[data-sectie]').forEach(function (s) { navObs.observe(s); });
      }

      var vast = el('vast');
      var koopt = root.querySelector('.bs-pp-koopt');
      if (vast && koopt) {
        /* De balk is met "Pre-order aanvragen" hoger dan met "In winkelwagen"
           (de regel eronder breekt dan af), dus meten we hem in plaats van een
           vast getal aan te houden. */
        var meetBalk = function () {
          if (!document.body || !document.body.style.setProperty) { return; }
          if (!vast.classList.contains('is-zichtbaar')) { return; }
          var hoog = Math.ceil(vast.getBoundingClientRect().height);
          if (hoog > 0) { document.body.style.setProperty('--bs-pp-balk-h', hoog + 'px'); }
        };
        document.addEventListener('bs:variant', meetBalk);
        window.addEventListener('resize', meetBalk);
        var vastObs = new IntersectionObserver(function (items) {
          items.forEach(function (it) {
            var zichtbaar = !it.isIntersecting && it.boundingClientRect.top < 0;
            vast.classList.toggle('is-zichtbaar', zichtbaar);
            vast.setAttribute('aria-hidden', zichtbaar ? 'false' : 'true');
            /* Ruimte onderaan de HELE pagina, niet alleen onder deze sectie: de
               voet staat buiten .bs-pp en lag anders onder de balk (nameting 4.1).
               De hoogte meten we, want de balk mag op 360 px twee regels worden. */
            root.classList.toggle('is-vast-zichtbaar', zichtbaar);
            if (document.body) {
              document.body.classList.toggle('bs-pp-balk-ruimte', zichtbaar);
              meetBalk();
            }
            var knop = vast.querySelector('button');
            if (knop) { knop.tabIndex = zichtbaar ? 0 : -1; }
          });
        });
        vastObs.observe(koopt);
      }
    }

    /* openen via een #anker in de URL (bijvoorbeeld een link naar #bs-pp-faq-...) */
    if (window.location.hash) {
      try { openSectie(document.getElementById(window.location.hash.slice(1))); } catch (e) { /* ongeldige hash */ }
    }

    /* beginstand gelijkzetten (zelfde variant, dus geen URL-wijziging) */
    var lengtesDoos = el('lengtes');
    if (lengtesDoos) {
      lengtesDoos.setAttribute('data-diameter', String(huidig.diameter));
      lengtesDoos.setAttribute('data-aantal', String(lengtesDoos.children.length));
    }
    zetDiaAan(0);
    /* Knoppen en de pre-orderuitleg gelijkzetten met de variantgegevens. Liquid heeft
       dit al goed gerenderd; dit vult de melding en vangt een verschil op. */
    zetVoorraad();
    /* Nog een keer zodra alle scripts gedraaid hebben (zie nogmaals hieronder):
       bs-preorder.js wordt verderop in de pagina ingeladen. */
    nogEens.push(function () { if (!bezig) { zetVoorraad(); } });
  }

  function initAlles() {
    alles(document, '[data-bs-product]').forEach(init);
  }

  /* Elke sectie laat hier een functie achter die de voorraadstand opnieuw zet.
     Nodig omdat snippets/bs-preorder.liquid zijn script pas ONDERAAN de sectie
     inlaadt: allebei de bestanden staan op defer, dus bs-product.js draait eerst
     en dan bestaat window.BSPreorder nog niet. De pre-orderuitleg (melding M1)
     bleef daardoor bij een uitverkochte maat leeg tot de eerste variantwissel. */
  var nogEens = [];
  function nogmaals() {
    nogEens.forEach(function (f) { try { f(); } catch (e) { /* een lege melding is geen crash waard */ } });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAlles);
  } else {
    initAlles();
  }
  /* Ook als initAlles hierboven al gedraaid heeft: defer-scripts draaien in
     paginavolgorde en voor DOMContentLoaded, dus dan bestaat BSPreorder wel. */
  document.addEventListener('DOMContentLoaded', nogmaals);
  if (document.readyState === 'complete') { nogmaals(); }
  document.addEventListener('shopify:section:load', function (e) {
    var t = e && e.target;
    if (t && t.querySelector) {
      var r = t.querySelector('[data-bs-product]');
      if (r) { init(r); }
    }
  });

})();
